import { DOCUMENT } from "@angular/common";
import { Inject, Injectable, Renderer2 } from "@angular/core";
import { IEneIconProject } from "./icon.interface";

@Injectable({ providedIn: "root" })
export class EneIconService {
  public loadedFonts: Array<string> = [];
  public availableProjects: Array<IEneIconProject> = [
    {
      name: "energycity",
      font: "/assets/icons/energycity-icons/css/energycity-icons.css"
    },
    {
      name: "digikoo",
      font: "/assets/icons/digikoo-icons/css/digikoo-icons.css"
    }
  ];

  constructor(@Inject(DOCUMENT) private document: any) {}

  /**
   * @description Attach font file if provided project name is correct.
   *
   * @param project Name of the project that exist in asstes folder.
   */
  public initIconFont(project: string, renderer: Renderer2): void {
    if (!this.loadedFonts.includes(project)) {
      this.loadedFonts.push(project);

      const headEl: HTMLHeadElement = this.document.getElementsByTagName("head")[0];
      const linkEl: HTMLLinkElement = renderer.createElement("link");

      renderer.setAttribute(linkEl, "type", "text/css");
      renderer.setAttribute(linkEl, "rel", "stylesheet");
      renderer.setAttribute(linkEl, "href", `/assets/icons/${project}-icons/css/${project}-icons.css`);

      renderer.appendChild(headEl, linkEl);
    }
  }
}
